const PLUGIN_CONST = {
  langSeperator: '::',
  tokenName: 'codegroup',
};

module.exports = PLUGIN_CONST;

